import React, { useEffect } from "react";
import {useDispatch, useSelector} from "react-redux";
import BeppoLogo from "../common/assets/beppo-logo-119x47.svg";
import LanguageMenu from "./languageMenu";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown, faAngleUp } from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import Style from "./navbar.module.scss";
import { useAvailableLanguages } from "../util/internationalization";
import {RootState} from "../reducers";

const Navbar = () => {
  const [openMenu, setOpenMenu] = useState(false);
  const menu = () => {
    setOpenMenu(!openMenu);
  };

  const closeMenu = () => {
    setOpenMenu(false);
  };
  const changeLanguageLabel = (label: string) => {
    setLanguage(label);
  };
  const { i18n } = useTranslation();

  const [language, setLanguage] = useState(i18n.language.toUpperCase());
  const ticket = useSelector((state: RootState) => state.ticket.ticket);

  const availableLanguages = useAvailableLanguages();

  useEffect(() => {
    const savedLanguage = localStorage.getItem("beppoSelectedLanguage") || i18n.language;

    if (!availableLanguages.includes(savedLanguage)) {
      const defaultLanguage = availableLanguages[0];
      i18n.changeLanguage(defaultLanguage);
      changeLanguageLabel(defaultLanguage.toUpperCase());
      localStorage.setItem("beppoSelectedLanguage", defaultLanguage);
    }
  }, [ticket]);


  return (
    <nav
      className="navbar navbar-expand-lg navbar-light "
      style={{
        backgroundColor: "white",
        display: "flex",
        justifyContent: "space-between",
        height: "80px",
      }}
    >
      <div className={`navbar-brand ${Style.navbarLogo}`}>
        <img src={BeppoLogo} id="beppoLogo" alt="beppo-logo" height={38} />
      </div>
      <div className={Style.languageSwitchContainer}>
        <div
          onClick={menu}
          className={Style.languageSwitchContainer__currentLanguage}
        >
          <FontAwesomeIcon icon={openMenu ? faAngleUp : faAngleDown} />
          <div>{language}</div>
        </div>
        {openMenu && (
          <LanguageMenu
            closeMenu={closeMenu}
            changeLanguageLabel={changeLanguageLabel}
            availableLanguages={availableLanguages}
          />
        )}
      </div>
    </nav>
  );
};

export default Navbar;
